import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared/services/shared.service';

@Component({
  selector: 'app-sign-page',
  templateUrl: './sign-page.component.html',
  styleUrls: ['./sign-page.component.scss']
})
export class SignPageComponent implements OnInit {
  isMobile: boolean = false;
  constructor(
    private sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.isMobile = this.sharedService.isMobile;
  }

}
